import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { ActivatedRoute } from '@angular/router';
import { ElectroDocumentService } from 'src/app/kuba/electro/services/electro-document.services';

import { TranslateService } from '@ngx-translate/core';
import { HelperService } from 'src/app/_services/helper.service';
import * as _ from 'lodash';
import { ArticleContent } from 'src/app/shared/ecpl-article-viewer/interfaces';
import { Subscription } from 'rxjs';

@Component({
    selector: 'electro-facts-abt-company',
    templateUrl: 'electro-facts-abt-company.component.html',
    styleUrls: ['electro-facts-abt-company.component.css'],
  standalone: false
})

export class ElectroFactsAbtCompanyComponent implements OnInit {

    @Input() editMode: boolean;
    @Input() facts: any;
    @Input() articleSrc: ArticleContent;
    private readonly notifications = inject(NotificationService);
    @Output() save: EventEmitter<any> = new EventEmitter<any>();
    showModalWindow: boolean;
    displayDate: any;
    modifiedOnNative: Date | null = null;
    contractId: any;
    private subscriptions: Subscription[] = [];
    constructor(private route: ActivatedRoute,
        private translator: TranslateService,
        private electroDocumentServices: ElectroDocumentService) {
            this.articleSrc = this.articleSrc;
         }

    ngOnInit() {
        this.facts = JSON.parse(this.facts);
        // preserve legacy value but set a native Date for p-calendar binding
        this.modifiedOnNative = HelperService.formatedInputDate(this.facts.FactsData.ModifiedOn);
        if (this.modifiedOnNative) {
            this.displayDate = this.modifiedOnNative.toLocaleDateString('en-GB');
        } else {
            this.displayDate = '';
        }
        this.contractId = +this.route.snapshot.params['Id'];
    }

  /**
   * show model event.
   */
    showModal() {
        this.showModalWindow = true;
    }

  /**
   * hide model event.
   */
    hideModal() {
        this.showModalWindow = false;
    }

  /**
   * get current date
   */
    getCurrentDate(date = null) {
        // legacy helper kept for backward compatibility; returns formatted object for callers if needed
        let dtObj = date ? HelperService.formatedInputDate(date) : new Date();
        if (!dtObj) dtObj = new Date();

        const dt = {
            date: {
                year: dtObj.getFullYear(),
                month: dtObj.getMonth() + 1,
                day: dtObj.getDate()
            },
            formatted: dtObj.toLocaleDateString('en-GB'),
            jsDate: dtObj
        };
        this.displayDate = dtObj.toLocaleDateString('en-GB');
        return dt;
    }

    updateTextVersion() {
        this.articleSrc.subArticles.forEach((element:any) => {
            element.version = this.articleSrc.article.version;
        });
    }

  /**
   * save facts
   */
    saveFacts() {
        this.facts.FactsData.BusinessId = BaseServices.BusinessId;
        this.facts.FactsData.ElectroContractId = this.route.snapshot.params['Id'];
        // ensure backend-compatible formatted value
        const dateForSave = this.modifiedOnNative
            ? this.modifiedOnNative
            :this.facts.FactsData.ModifiedOn && this.facts.FactsData.ModifiedOn.formatted
                ? this.facts.FactsData.ModifiedOn.formatted
                : this.facts.FactsData.ModifiedOn;
        this.facts.FactsData.ModifiedOn = HelperService.formatDateFilter(dateForSave);
        if (this.facts.FactsData.Id) {
            this.facts.FactsData.ModifiedBy = BaseServices.UserId;
            this.subscriptions.push(this.electroDocumentServices.updateFactsAboutCompany(this.facts.FactsData).subscribe(result => {
                if (result) {
                    this.notifications.success('UI_NOTIFICATIONS.SAVED');
                    this.save.emit();
                }
            }));
        }
        else {
            this.facts.FactsData.CreatedBy = BaseServices.UserId;
            this.subscriptions.push(this.electroDocumentServices.saveFactsAboutCompany(this.facts.FactsData).subscribe(result => {
                if (result) {
                    this.notifications.success('UI_NOTIFICATIONS.SAVED');
                    this.save.emit();
                }
            }));
        }
    }

  /**
   * print fact as pdf event.
   */
    printFactPdf() {
        let type = 'pdf';
        let appSettings = JSON.parse(sessionStorage.getItem('appSettings'));
        let languageId = appSettings.Language.LanguageId;
        let CultureInfo = BaseServices.userCultureInfo();
        this.subscriptions.push(this.electroDocumentServices
            .generateFactsAboutCompanyPdf(this.contractId, CultureInfo)
            .subscribe(
                blob => {
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `${this.translator.instant('FACTS_ABOUT_THE_COMPANY')}.${type.toLowerCase()}`;
                    link.click();
                },
                error => {
                    
                }));
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sub, i) => {
          sub.unsubscribe();
        });
      }
}